<template>
  <div class="bg-gray px-4 py-3 rounded">
    <div class="mb-3">
      <icon-view
        :has-border="false"
        icon="fas fa-file-plus text-orange"
        icon-size="17px"
        title="Añadir Libro"
        variant="custom-icon-view"
        icon-background="white"
      />
    </div>

    <validation-observer ref="validator" novalidate tag="form">
      <div class="row">
        <div class="col-12 col-md">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-drop-down
              label="Materia:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              class="w-100 mb-4 bold-label"
              custom-error-msg="Favor seleccione una materia"
              v-model="model.subject"
              :options="subjects"
              :error="errors[0]"
            />
          </validation-provider>
        </div>
        <div class="col-12 col-md">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-input
              v-model="model.name"
              custom-error-msg="El titulo de libro es requerido"
              :error="errors[0]"
              label="Título del Libro:"
              placeholder="Título del Libro"
            />
          </validation-provider>
        </div>
        <div
          class="col-12 col-md-2 mt-3 mt-md-0"
          :class="{ 'px-0': !isMobile }"
        >
          <div
            class="d-flex align-items-center h-100"
            :class="{ 'flex-column': isMobile }"
          >
            <div :class="{ 'w-100 mb-2': isMobile }">
              <action-button
                id="btnCancel"
                i="fas fa-times-circle"
                text="Cancelar"
                :variant="
                  isMobile
                    ? 'outline-danger mr-2 w-100'
                    : 'outline-danger mr-2 mt-2'
                "
                @click="cancel"
              />
            </div>
            <div :class="{ 'w-100': isMobile }">
              <action-button
                id="btnSave"
                i="fas fa-file-plus"
                text="Guardar"
                :variant="isMobile ? 'success w-100' : 'success mt-2'"
                @click="save"
              />
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import IconView from "icon-view";
import CustomDropDown from "custom-drop-down";
import CustomInput from "CustomInput";
import ActionButton from "ActionButton";
import alertMixin from "@/mixin/alert.mixin";

export default {
  name: "AddBook",
  components: {
    IconView,
    CustomDropDown,
    CustomInput,
    ActionButton
  },
  mixins: [alertMixin],
  props: {
    subjects: {
      type: Array,
      require: true,
      default: () => []
    }
  },
  data() {
    return {
      model: {
        subject: null,
        name: null
      }
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    }
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    async save() {
      const valid = await this.$refs.validator.validate();
      if (!valid) {
        this.ShowToast(
          "Alerta",
          "Por favor, completa los campos requeridos.",
          "error"
        );
        return;
      }
      this.$emit("save", this.model);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .dot {
  padding: 19px !important;
}
</style>
